<app-video-tool-header
  [menuConfig]="menu"
  [userInfo]="userInfo" 
></app-video-tool-header>